export default "__VITE_ASSET__673c2399__"